import * as Sentry from "@sentry/browser";
import { sanitizeEvent } from "./sentry-privacy.mjs";
import "./browser-analytics.mjs";

// Queue early failures while fetching public configuration; never delay gameplay.
const pending = [];
const onError = (event) => {
  if (event.error instanceof Error && pending.length < 10) pending.push(event.error);
};
const onRejection = (event) => {
  if (event.reason instanceof Error && pending.length < 10) pending.push(event.reason);
};
window.addEventListener("error", onError);
window.addEventListener("unhandledrejection", onRejection);
const stopQueue = () => {
  window.removeEventListener("error", onError);
  window.removeEventListener("unhandledrejection", onRejection);
};
const backend = window.MJ_BACKEND || "";
const controller = new AbortController();
const timeout = setTimeout(() => controller.abort(), 5000);
fetch(`${backend}/pg-api/monitoring-config`, {
  credentials: "omit", signal: controller.signal,
}).then((response) => response.ok ? response.json() : null).then((config) => {
  window.MJAnalytics?.configure(config?.analyticsEnabled);
  if (!config?.dsn) return;
  Sentry.init({
    dsn: config.dsn, environment: config.environment,
    // An installed app keeps its own release when the backend is redeployed.
    release: window.MJ_NATIVE ? (__MJ_MONITORING_RELEASE__ || config.release) : config.release,
    sendDefaultPii: false, autoSessionTracking: false,
    defaultIntegrations: false,
    integrations: [Sentry.globalHandlersIntegration(), Sentry.browserApiErrorsIntegration(), Sentry.dedupeIntegration()],
    beforeSend: sanitizeEvent,
    tracesSampleRate: 0,
  });
  Sentry.setTag("platform", window.MJ_PLATFORM || "web");
  stopQueue();
  pending.forEach((error) => Sentry.captureException(error));
}).catch(() => {}).finally(() => { clearTimeout(timeout); stopQueue(); pending.length = 0; });
